module.exports = __webpack_public_path__ + "img/filter-region.f7960503.svg";